import styled from 'styled-components';

export const MobileHistoryDateRowStyled = styled.div`
    display: flex;
    justify-content: start;
    padding: 28px 0 12px;
    font-size: 14px;
    font-weight: 600;
    color: var(--color-label-secondary);
    
    &.first {
        padding-top: 0;
    }
`;
